/**
 * @generated SignedSource<<8f8b2bc1ce26d333d50f06ed4e95a7b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveWaitingPaymentMethodRoot_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveWaitingPaymentMethodPixCreditCard_query">;
  readonly " $fragmentType": "PaymentActiveWaitingPaymentMethodRoot_query";
};
export type PaymentActiveWaitingPaymentMethodRoot_query$key = {
  readonly " $data"?: PaymentActiveWaitingPaymentMethodRoot_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveWaitingPaymentMethodRoot_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveWaitingPaymentMethodRoot_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveWaitingPaymentMethodPixCreditCard_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ace443e38be87eec9aa03b69996cb0f5";

export default node;
